var _circle, _circle2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 62,
    viewBox: "0 0 61 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 31,
    r: 30,
    fill: "white",
    stroke: "#CDCEDE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5001,
    cy: 31.0001,
    r: 26.6876,
    fill: "#F3F3F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_200_16113)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.5,
    height: 30.5,
    transform: "translate(15.25 15.75)",
    fill: "#F3F3F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0834 25.9166C35.0834 28.449 33.0324 30.4999 30.5 30.4999C27.9676 30.4999 25.9167 28.449 25.9167 25.9166C25.9167 23.3842 27.9676 21.3333 30.5 21.3333C33.0324 21.3333 35.0834 23.3842 35.0834 25.9166ZM20.8334 38.6249C20.8334 37.9635 21.1608 37.3471 21.7839 36.772C22.4104 36.1937 23.302 35.6917 24.3302 35.2797C26.3875 34.4556 28.866 34.0416 30.5 34.0416C32.1341 34.0416 34.6126 34.4556 36.6699 35.2797C37.6981 35.6917 38.5897 36.1937 39.2162 36.772C39.8393 37.3471 40.1667 37.9635 40.1667 38.6249V40.6666H20.8334V38.6249Z",
    fill: "#CBCAED",
    stroke: "#440AA0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_200_16113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.5,
    height: 30.5,
    fill: "white",
    transform: "translate(15.25 15.75)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.59843e86647110da4ca1a7f6131f05ad.svg";
export { ForwardRef as ReactComponent };